import { render, staticRenderFns } from "./device-filter.vue?vue&type=template&id=50d7a904&scoped=true"
import script from "./device-filter.vue?vue&type=script&lang=js"
export * from "./device-filter.vue?vue&type=script&lang=js"
import style0 from "./device-filter.vue?vue&type=style&index=0&id=50d7a904&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50d7a904",
  null
  
)

export default component.exports